import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { PixelPlaceholderLoader } from "@similarweb/ui-components";

import { DEFAULT_MAX_CHARACTERS, TEST_SELECTORS } from "./constants";
import * as SC from "./styles";
import type { InputSchema } from "./types";

const Input = ({
    isError = false,
    isDisabled = false,
    onChange,
    errorMessage,
    maxLength = DEFAULT_MAX_CHARACTERS,
    value,
    className,
    isLoading = false,
    autoFocus = false,
    placeholder = "",
}: InputSchema) => {
    if (isLoading) {
        return (
            <PixelPlaceholderLoader
                height="auto"
                width="100%"
            />
        );
    }

    return (
        <SC.InputWrapper
            className={className}
            data-automation={TEST_SELECTORS.inputWrapper}
        >
            <SC.StyledInput
                isDisabled={isDisabled}
                isError={isError}
                onChange={onChange}
                maxLength={maxLength}
                value={value}
                data-automation={TEST_SELECTORS.inputElement}
                autoFocus={autoFocus}
                placeholder={placeholder}
            />

            {isError ? (
                <SC.IconWrapper data-automation={TEST_SELECTORS.errorIcon}>
                    <SWReactIcons
                        iconName="info-full"
                        iconColor={colorsPalettes.red["400_P"]}
                        size="sm"
                    />
                </SC.IconWrapper>
            ) : null}

            {isError && errorMessage ? (
                <SC.NameError data-automation={TEST_SELECTORS.errorName}>{errorMessage}</SC.NameError>
            ) : null}
        </SC.InputWrapper>
    );
};

export default Input;
